export const landingTranslations = {
  en: {
    nav: {
      tryButton: 'Try MapSound'
    },
    hero: {
      title: 'MapSound',
      subtitle: 'Create Sound Layers Across the Real World',
      description: 'Transform streets, parks and landmarks into immersive audio experiences for your audience.',
      tryButton: 'Try MapSound',
      contactButton: 'Contact Us for a Project'
    },
    intro: {
      title: 'Turn Any Location Into a Sound Experience',
      description: 'With MapSound, you can draw zones or routes on a map, attach music or narration, and publish QR codes for visitors to experience sound in the real world — no speakers, no installations, no apps.'
    },
    features: {
      soundDrops: {
        title: 'Sound Drops',
        description: 'Place one or more sound moments in a precise location — visitors step in, and the audio plays.'
      },
      soundZones: {
        title: 'Sound Zones',
        description: 'Define areas on the map and curate playlists for everyone inside.'
      },
      soundTrails: {
        title: 'Sound Trails',
        description: 'Guide visitors along sequenced Sound Stops — each with its own track, story, or ambience.'
      },
      listeningRadius: {
        title: 'Listening Radius',
        description: 'Control how far your audio reaches. Choose from intimate 5m stops to wide 50m soundscapes.'
      },
      qrAccess: {
        title: 'QR Access (No Login)',
        description: 'Generate branded QR codes that launch instant playback for any Sound Zone or Stop.'
      }
    },
    howItWorks: {
      title: 'How It Works',
      step1: { title: 'Draw', description: 'Create Sound Zones or Trails on the map.' },
      step2: { title: 'Add Sound', description: 'Upload or link tracks and set their radius and order.' },
      step3: { title: 'Share', description: 'Print QR codes and place them on-site. Visitors scan and listen instantly.' }
    },
    useCases: {
      title: 'Business Use Cases',
      tourism: { title: 'Tourism Boards', description: 'Turn landmarks into narrated soundwalks.' },
      fitness: { title: 'Fitness Brands', description: 'Design audio-guided running or walking routes.' },
      artCulture: { title: 'Art & Culture', description: 'Create citywide installations where sound meets place.' }
    },
    pricing: {
      title: 'Pricing Tiers',
      starter: { name: 'Starter', price: 'Free', feature1: '3 Sound Zones', feature2: '1 Sound Trail', feature3: '3 QR campaigns' },
      pro: { name: 'Pro', price: '$49', perMonth: '/mo', popular: 'Popular', feature1: '20 Sound Zones', feature2: '5 Sound Trails', feature3: 'Custom QR branding', feature4: 'Analytics' },
      business: { name: 'Business', price: '$199', perMonth: '/mo', feature1: '50 Sound Zones', feature2: '15 Sound Trails', feature3: 'Multilingual support', feature4: 'API access' }
    },
    vision: {
      title: 'When Every Place Has Its Own Sound...',
      subtitle: '...the city becomes a Sonic City.',
      description: 'MapSound is the tool to get there.'
    },
    cta: { title: 'Ready to map your first sound?', button: 'Start Creating' },
    footer: {
      links: { privacy: 'Privacy', terms: 'Terms', contact: 'Contact' },
      copyright: '© 2024 MapSound. All rights reserved.'
    }
  },
  ko: {
    nav: {
      tryButton: 'MapSound 체험하기'
    },
    hero: {
      title: 'MapSound',
      subtitle: '실제 세계에 사운드 레이어 만들기',
      description: '거리, 공원, 랜드마크를 청중을 위한 몰입형 오디오 경험으로 변환하세요.',
      tryButton: 'MapSound 체험하기',
      contactButton: '프로젝트 문의하기'
    },
    intro: {
      title: '모든 장소를 사운드 경험으로 바꾸기',
      description: 'MapSound를 사용하면 지도에 구역이나 경로를 그리고 음악이나 내레이션을 첨부하며, 방문자가 실제 세계에서 사운드를 경험할 수 있도록 QR 코드를 게시할 수 있습니다 — 스피커, 설치물, 앱 없이.'
    },
    features: {
      soundDrops: {
        title: 'Sound Drops',
        description: '정확한 위치에 하나 이상의 사운드 순간을 배치하세요 — 방문자가 들어오면 오디오가 재생됩니다.'
      },
      soundZones: {
        title: 'Sound Zones',
        description: '지도에서 영역을 정의하고 내부의 모든 사람을 위한 재생 목록을 큐레이팅하세요.'
      },
      soundTrails: {
        title: 'Sound Trails',
        description: '순차적인 Sound Stops를 따라 방문자를 안내하세요 — 각각 고유한 트랙, 스토리 또는 분위기가 있습니다.'
      },
      listeningRadius: {
        title: 'Listening Radius',
        description: '오디오가 도달하는 거리를 제어하세요. 친밀한 5m 정류장부터 넓은 50m 사운드스케이프까지 선택하세요.'
      },
      qrAccess: {
        title: 'QR Access (로그인 불필요)',
        description: '모든 Sound Zone 또는 Stop에 대한 즉각적인 재생을 시작하는 브랜드 QR 코드를 생성하세요.'
      }
    },
    howItWorks: {
      title: '작동 방식',
      step1: { title: '그리기', description: '지도에 Sound Zones 또는 Trails를 만드세요.' },
      step2: { title: '사운드 추가', description: '트랙을 업로드하거나 링크하고 반경과 순서를 설정하세요.' },
      step3: { title: '공유', description: 'QR 코드를 인쇄하고 현장에 배치하세요. 방문자는 스캔하고 즉시 듣습니다.' }
    },
    useCases: {
      title: '비즈니스 사용 사례',
      tourism: { title: '관광청', description: '랜드마크를 내레이션 사운드워크로 바꾸세요.' },
      fitness: { title: '피트니스 브랜드', description: '오디오 가이드 러닝 또는 워킹 경로를 디자인하세요.' },
      artCulture: { title: '예술 & 문화', description: '사운드가 장소와 만나는 도시 전체의 설치물을 만드세요.' }
    },
    pricing: {
      title: '가격 플랜',
      starter: { name: '스타터', price: '무료', feature1: '3개 Sound Zones', feature2: '1개 Sound Trail', feature3: '3개 QR 캠페인' },
      pro: { name: '프로', price: '$49', perMonth: '/월', popular: '인기', feature1: '20개 Sound Zones', feature2: '5개 Sound Trails', feature3: '맞춤 QR 브랜딩', feature4: '분석' },
      business: { name: '비즈니스', price: '$199', perMonth: '/월', feature1: '50개 Sound Zones', feature2: '15개 Sound Trails', feature3: '다국어 지원', feature4: 'API 액세스' }
    },
    vision: {
      title: '모든 장소가 고유한 사운드를 가질 때...',
      subtitle: '...도시는 Sonic City가 됩니다.',
      description: 'MapSound는 그곳에 도달하는 도구입니다.'
    },
    cta: { title: '첫 번째 사운드를 매핑할 준비가 되셨나요?', button: '만들기 시작' },
    footer: {
      links: { privacy: '개인정보', terms: '약관', contact: '문의' },
      copyright: '© 2024 MapSound. All rights reserved.'
    }
  },
  ja: {
    nav: {
      tryButton: 'MapSoundを試す'
    },
    hero: {
      title: 'MapSound',
      subtitle: '現実世界にサウンドレイヤーを作成',
      description: '通り、公園、ランドマークを観客のための没入型オーディオ体験に変換します。',
      tryButton: 'MapSoundを試す',
      contactButton: 'プロジェクトのお問い合わせ'
    },
    intro: {
      title: 'あらゆる場所をサウンド体験に',
      description: 'MapSoundを使用すると、地図上にゾーンやルートを描き、音楽やナレーションを添付し、訪問者が実世界でサウンドを体験できるようQRコードを公開できます — スピーカー、設置物、アプリなしで。'
    },
    features: {
      soundDrops: {
        title: 'Sound Drops',
        description: '正確な場所に1つ以上のサウンドモーメントを配置 — 訪問者が入るとオーディオが再生されます。'
      },
      soundZones: {
        title: 'Sound Zones',
        description: '地図上にエリアを定義し、その中の全員のためにプレイリストをキュレート。'
      },
      soundTrails: {
        title: 'Sound Trails',
        description: '順序付けられたSound Stopsに沿って訪問者を案内 — それぞれ独自のトラック、ストーリー、または雰囲気があります。'
      },
      listeningRadius: {
        title: 'Listening Radius',
        description: 'オーディオが届く距離を制御。親密な5mストップから広い50mサウンドスケープまで選択できます。'
      },
      qrAccess: {
        title: 'QR Access (ログイン不要)',
        description: 'あらゆるSound ZoneまたはStopの即時再生を開始するブランドQRコードを生成。'
      }
    },
    howItWorks: {
      title: '使い方',
      step1: { title: '描く', description: '地図上にSound ZonesまたはTrailsを作成。' },
      step2: { title: 'サウンドを追加', description: 'トラックをアップロードまたはリンクし、半径と順序を設定。' },
      step3: { title: 'シェア', description: 'QRコードを印刷し、現地に配置。訪問者はスキャンして即座に聴きます。' }
    },
    useCases: {
      title: 'ビジネスユースケース',
      tourism: { title: '観光局', description: 'ランドマークをナレーション付きサウンドウォークに。' },
      fitness: { title: 'フィットネスブランド', description: 'オーディオガイド付きランニングまたはウォーキングルートをデザイン。' },
      artCulture: { title: 'アート＆カルチャー', description: 'サウンドが場所と出会う都市全体のインスタレーションを作成。' }
    },
    pricing: {
      title: '料金プラン',
      starter: { name: 'スターター', price: '無料', feature1: '3 Sound Zones', feature2: '1 Sound Trail', feature3: '3 QRキャンペーン' },
      pro: { name: 'プロ', price: '$49', perMonth: '/月', popular: '人気', feature1: '20 Sound Zones', feature2: '5 Sound Trails', feature3: 'カスタムQRブランディング', feature4: '分析' },
      business: { name: 'ビジネス', price: '$199', perMonth: '/月', feature1: '50 Sound Zones', feature2: '15 Sound Trails', feature3: '多言語サポート', feature4: 'APIアクセス' }
    },
    vision: {
      title: 'すべての場所が独自のサウンドを持つとき...',
      subtitle: '...都市はSonic Cityになります。',
      description: 'MapSoundはそこに到達するためのツールです。'
    },
    cta: { title: '最初のサウンドをマッピングする準備はできましたか？', button: '作成を開始' },
    footer: {
      links: { privacy: 'プライバシー', terms: '利用規約', contact: 'お問い合わせ' },
      copyright: '© 2024 MapSound. All rights reserved.'
    }
  }
};
